import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  CreateUserInput,
  CreateUserResponse,
  LoginInput,
  UserResponse
} from '@shared/types/user.types';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/auth/`
  }),
  endpoints: builder => ({
    // Login
    login: builder.mutation<UserResponse, LoginInput>({
      query: body => ({
        url: 'login',
        method: 'POST',
        body
      })
    }),

    // Sign Up
    createUser: builder.mutation<CreateUserResponse, CreateUserInput>({
      query: body => ({
        url: 'create-account',
        method: 'POST',
        body
      })
    }),

    // Fetch user profile by token or userId
    fetchUser: builder.query<UserResponse, void>({
      query: () => 'me'
    })
  })
});

export const { useLoginMutation, useCreateUserMutation, useFetchUserQuery } =
  userApi;
